/**
 * Документы, с которыми человек соглашается при регистрации. Редакция — та же
 * строка, что у сервера (`sv_auth/.../auth/register.rs::TERMS_VERSION`) и в
 * подписи «Редакция от …» на сайте: меняется текст — меняются все три.
 */
export const TERMS_VERSION = '2026-10-27';
export const TERMS_URL = 'https://samvision.uz/terms';
export const PRIVACY_URL = 'https://samvision.uz/privacy';
